























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IBankAttribute, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'bankAttribute',
  }),
  mixins: [paginationMixin],
})
export default class BankAttributeList extends Vue {
  @Action('getEntities', { namespace: 'bankAttribute' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'bankAttribute' })
  entitiesSlice: IBankAttribute[];
  @State('pageParams', { namespace: 'bankAttribute' }) pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  created() {
    this.getEntities();
  }
}
